// A UTC timestamp that may arrive without its offset. JavaScript reads an ISO date-time with
// no offset as *local* time, which shifts it by the viewer's UTC offset. Ticket
// `additionalDetail` dates (`lastPing`, `newDataDate`) are UTC but sent without the `Z`,
// and tickets already stored will keep that shape even if the backend starts adding it.
//
// Strings that already carry `Z` or `±hh:mm` are left alone. Date-only strings are too:
// JavaScript already reads those as UTC, and `2026-08-24Z` would be an invalid date.
const HAS_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/i

export const parseUtc = (value: string) =>
  new Date(value.includes('T') && !HAS_OFFSET.test(value) ? `${value}Z` : value)
